import { IdSchema } from '@batiflow/contracts';
import { z } from 'zod';

/**
 * Search params of /s/$spaceId/$tab: the channel open in the Chat tab and the message to scroll
 * to, and the transmittals view of the Documents tab. An invalid value is simply dropped.
 */
export const SpaceSearchSchema = z.object({
  channel: IdSchema.optional().catch(undefined),
  message: IdSchema.optional().catch(undefined),
  // The Documents tab's transmittals view and its open transmittal (GEDX-FE-02).
  view: z.literal('transmittals').optional().catch(undefined),
  transmittal: IdSchema.optional().catch(undefined),
});
export type SpaceSearch = z.infer<typeof SpaceSearchSchema>;
